module.exports = __webpack_public_path__ + "static/media/banner_m_01.e1220c95.jpg";